export const FETCH_USER_PERMISSIONS = 'FETCH_USER_PERMISSIONS';

export const fetchUserPermissions = (value: any[]) => {
    return {
        type: FETCH_USER_PERMISSIONS,
        payload: value
    }
}
